export const countAllNodes = (nodeMap, rootId) => {
  if (!nodeMap || !nodeMap[rootId]) return 0;
  let count = 0;
  const stack = [rootId];

  while (stack.length) {
    const currentId = stack.pop();
    const node = nodeMap[currentId];
    if (!node) continue;

    // Only count if not an AccordionContainer
    if (node?.type?.resolvedName !== "AccordionContainer") {
      count += 1;
    }

    // Push its children and linked nodes onto the stack
    stack.push(...(node.nodes || []), ...Object.values(node.linkedNodes || {}));
  }

  return count;
};

export const segmentsAreSame = (a, b) => {
  if (a.length !== b.length) return false;
  return a.every((seg, i) => seg.value === b[i].value && seg.id === b[i].id);
};

// Helper to strip HTML tags from a string
export const stripHtmlTags = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "");
};

// Helper function to get plain text character count from HTML
export const getHtmlCharCount = (html) => {
  if (!html) return 0;

  // Create a temporary div to parse the HTML
  const temp = document.createElement("div");
  temp.innerHTML = html;

  // Get the text content (without HTML tags)
  const textContent = temp.textContent || temp.innerText || "";
  return textContent.length;
};

// Count the total characters in text nodes of a segment
export const countTextCharacters = (nodeMap, rootId) => {
  if (!nodeMap || !nodeMap[rootId]) return 0;
  let charCount = 0;
  const stack = [rootId];

  while (stack.length) {
    const currentId = stack.pop();
    const node = nodeMap[currentId];
    if (!node) continue;

    // Count text in TextWidget and ImageWithText nodes using DOM approach
    if (node?.type?.resolvedName === "TextWidget" && node?.props?.text) {
      charCount += getHtmlCharCount(node.props.text);
    } else if (
      node?.type?.resolvedName === "ImageWithText" &&
      node?.props?.text
    ) {
      charCount += getHtmlCharCount(node.props.text);
    }

    // Continue checking children nodes
    stack.push(...(node.nodes || []), ...Object.values(node.linkedNodes || {}));
  }

  return charCount;
};

//for craft js content calculation
export const tryMeasureSegment = (segment, query) => {
  if (!segment.nodes) return null;
  try {
    const nodeMap =
      typeof segment.nodes === "string"
        ? JSON.parse(segment.nodes)
        : segment.nodes;
    const root = nodeMap["ROOT"];
    if (!root) return null;

    const childIds = root.nodes || [];
    if (!childIds.length) return 1;

    let total = 0;
    childIds.forEach((childId) => {
      const nodeData = query.node(childId).get();
      // If the node is currently rendered, nodeData.dom exists

      if (nodeData?.dom) {
        total += nodeData.dom.offsetHeight || 0;
      }
    });
    if (total > 0) {
      return total;
    }
  } catch (err) {
    console.log("Error measuring segment:", err);
  }
  return null; // means no real DOM found or error
};
